import { forwardRef, PropsWithChildren } from 'react';
import cx from 'clsx';

import styles from './styles.module.css';

type CircularButtonProps = PropsWithChildren<{
  className?: string;
  onClick?: () => void;
}>;

export const CircularButton = forwardRef<
  HTMLButtonElement,
  CircularButtonProps
>(({ children, className, onClick }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={cx(styles.button, className)}
      onClick={onClick}
    >
      {children}
    </button>
  );
});
